import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
import { Select } from '@lean-body/components/atoms';
const { useState, useEffect } = React;
const TIME_SELECT_STEP_DEFAULT = 5;
export const TimeSelectFormat = {
    hmm: 'h:mm',
    hhmm: 'hh:mm',
};
export const TimeSelectForm = ({ containerClassObject, selectClassObject, listClassObject, listItemClassObject, currentValue, setCurrentValue, label, format, step, displayIcon, }) => {
    const [time, setTime] = useState(currentValue);
    useEffect(() => {
        setTime(currentValue);
    }, [currentValue]);
    const changeTime = (event) => {
        setTime(event.target.value);
        setCurrentValue(event.target.value);
    };
    const generateOptions = () => {
        const options = [{ value: '', name: '' }];
        const delta = step !== null && step !== void 0 ? step : TIME_SELECT_STEP_DEFAULT;
        const stepsInHour = 60 / delta;
        for (let i = 0; i < 24 * stepsInHour; i++) {
            const hour = Math.floor(i / stepsInHour);
            const minute = (i % stepsInHour) * delta;
            const hourString = format === TimeSelectFormat.hmm ? hour.toString() : hour.toString().padStart(2, '0');
            const minuteString = minute.toString().padStart(2, '0');
            const value = `${hourString}:${minuteString}`;
            options.push({ value: value, name: value });
        }
        return options;
    };
    return (React.createElement("div", { className: css(containerClassObject) },
        label && React.createElement("div", { className: css(styles.label) }, label),
        React.createElement("div", { className: css(styles.selectContainer) },
            React.createElement(Select, { selectOptions: generateOptions(), defaultValue: time, containerClassObject: styles.select, selectClassObject: [styles.select, selectClassObject], listClassObject: listClassObject, listItemClassObject: listItemClassObject, onChange: changeTime, displayIcon: displayIcon !== null && displayIcon !== void 0 ? displayIcon : true, placeholder: "", placeholderValue: "" }))));
};
const styles = StyleSheet.create({
    selectContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
    },
    select: {
        width: '100%',
    },
    label: {
        fontSize: 14,
        color: Colors.GrayDarkest,
        marginBottom: 8,
    },
});
